module.exports = __webpack_public_path__ + "static/media/Alert.649235ae.svg";